export interface DailyRewardStatus {
  claimedToday: boolean;
  currentStreak: number;
  cookie: {
    text: string;
    image: string;
  };
  reward: number;
}

export enum DailyRewardTagTypes {
  DAILY_REWARD_STATUS = 'DailyRewardStatus',
}
